import { postRequest } from "./requests"
import { API_URL } from "./config"


export const controlDevice = (payload:{ uid:string, reactionTime:number, vibrationPower:number }) => postRequest(`${API_URL}/lovense/command.php`, payload)
export const getQRCode = (payload:{ 
    uid:string, 
    uname:string, 
    utoken:string 
}) => postRequest(`${API_URL}/lovense/qrcode.php`, payload)